<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="dedication">
<p class="ded" id="dedication"><span epub:type="pagebreak" id="page_iii"></span>To Jarod and Camille<span epub:type="pagebreak" id="page_iv"></span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?28841e7b